<vi-loader
  data-at-loader
  *ngIf="featuresLoading$ | async"
  [isLoading]="true"
  [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
></vi-loader>

<!-- device name -->
<ng-container *ngIf="deviceName$ | async | ready as deviceName">
  <app-feature-list-item
    data-at-device-name
    [label]="'+INSTALLATIONS.SRC.DEVICE.DESCRIPTION' | translate"
    [editable]="true"
    [value]="deviceName | value2: featurePropertyKey.name"
    (edit)="openEditDeviceNameDialog(deviceId)"
  >
  </app-feature-list-item>
</ng-container>

<!-- id -->
<app-feature-list-item data-at-id label="ID" [value]="deviceId | idPrefixRemover | serialSpacing">
</app-feature-list-item>

<!-- device error info message -->
<ng-container *ngIf="deviceErrors$ | async as deviceErrors">
  <app-feature-list-item
    data-ut-error
    *ngFor="let error of deviceErrors"
    [label]="error?.errorCode"
    [description]="error?.errorDescription"
    [value]="error?.appearedAt | date: 'short'"
    [error]="true"
  >
  </app-feature-list-item>
</ng-container>

<ng-container *ngIf="getFHTConnectionStatusFeature() | async as status">
  <!-- Device disconnected alert -->
  <app-feature-list-item
    *ngIf="installationService.isSrcDeviceNotConnected(status)"
    [isNgContent]="true"
  >
    <app-banner>
      {{ '+INSTALLATIONS.SRC.ETRV.DISCONNECTED' | translate: { time: status.timestamp | date:
      'short' } }}
    </app-banner>
  </app-feature-list-item>

  <!-- fht.valve -->
  <app-feature-list-item
    data-at-channel-valve
    *ngIf="valveOpenedOrClosed$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.VALVE_TYPE.TITLE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.type | translateValveType)
    }}"
    [attr.data-feature]="feature.feature + '/type'"
    [editable]="!installationService.isSrcDeviceNotConnected(status)"
    (edit)="openFhtModal(deviceId)"
  >
  </app-feature-list-item>

  <!-- fht.valve.position -->
  <app-feature-list-item
    data-at-channel-valve-position
    *ngIf="valvePosition$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.VALVE_POSITION.TITLE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature.properties?.value?.value | translateValvePosition)
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- fht.valve.burnInMode -->
  <app-feature-list-item
    data-at-channel-valve-burn-in-mode
    *ngIf="burnInMode$ | async | ready as feature"
    [label]="'+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.TITLE' | translate"
    [isNgContent]="true"
    [editable]="true"
    [forInput]="true"
    [attr.data-feature]="feature.feature"
  >
    <ng-container *ngIf="feature.properties?.active?.value">
      {{ '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.DURATION' | translate }}: 6 {{
      '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.DURATION_UNIT' | translate }}
    </ng-container>
    <mat-slide-toggle
      (click)="onBurnInModeChange($event, !feature.properties?.active?.value)"
      [checked]="feature.properties?.active?.value"
    ></mat-slide-toggle>
  </app-feature-list-item>

  <!-- device.heatingCircuitId -->
  <ng-container *ngIf="!(isSrcStandalone$ | async)?.properties?.active?.value">
    <app-feature-list-item
      data-at-heatingCircuitId
      *ngIf="gatewayStore.getHeatingCircuitOfDevice(deviceId) | async | ready as feature"
      [error]="feature | error"
      [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
      value="{{
        installationService.isSrcDeviceNotConnected(status)
          ? noValue
          : (installationService.getCircuitName(feature.properties?.value?.value.toString())
            | async)
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </ng-container>

  <!-- device.sensors.firmware-->
  <app-feature-list-item
    data-at-cs-sensor-firmware
    *ngIf="firmware$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.FIRMWARE' | translate"
    value="
        {{feature | value2: featurePropertyKey.value}}
      "
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>
</ng-container>
